<template>
  <v-dialog
    persistent
    @keydown.esc="hide"
    width="500"
    :value="editRelatedTags != null && role('admin', 'safetyRepresentative')"
    v-if="editRelatedTags != null && role('admin', 'safetyRepresentative')"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{
        $t("management.tag.column.relatedTags")
      }}</v-card-title>

      <v-card-text>
        <v-autocomplete
          class="mt-0 pt-0"
          v-model="newRelatedTags"
          :items="tagsCurrentRelatedAndWithoutParent"
          required
          chips
          deletable-chips
          :item-text="getTagTextWithActiveStatus"
          return-object
          multiple
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="removeTag(data.item)"
              :style="
                data.item.isActive ? '' : 'text-decoration: line-through;'
              "
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="save" :loading="loading">{{
          $t("dialog.assign")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TagsAllQuery from "@/graphql/queries/TagsAll.gql";
import ChangeRelatedTagsQuery from "@/graphql/mutation/tag/ChangeRelatedTags.gql";

import { mapGetters } from "vuex";
import { getDetailedTagText } from "@/utils/tag";

export default {
  props: ["editRelatedTags", "tagStats"],

  data() {
    return {
      newRelatedTags: [],
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["role"]),
  },

  watch: {
    editRelatedTags(newVal) {
      if (newVal) {
        this.newRelatedTags = [...newVal.relatedTags];
      }
    },
  },

  methods: {
    getTagTextWithActiveStatus(item) {
      return item.isActive
        ? getDetailedTagText(item)
        : `${this.$t("instructions.inactive")} ${getDetailedTagText(item)}`;
    },
    hide() {
      this.$emit("hide");
    },
    save() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ChangeRelatedTagsQuery,
          variables: {
            parentId: this.editRelatedTags.id,
            childIds: this.newRelatedTags.map((t) => t.id),
          },
        })
        .then(() => {
          this.$emit("update:relatedTags", {
            id: this.editRelatedTags.id,
            relatedTags: this.newRelatedTags,
          });
          this.hide();
        })
        .catch((err) =>
          this.$store.commit("push_global_message", {
            color: "error",
            text: `Failed to change related tags. Error: ${err}`,
          })
        )
        .finally(() => {
          this.loading = false;
        });
    },
    removeTag(tag) {
      const index = this.newRelatedTags.findIndex((t) => t.id === tag.id);
      if (index >= 0) {
        this.newRelatedTags.splice(index, 1);
      }
    },
  },

  apollo: {
    tagsCurrentRelatedAndWithoutParent: {
      query: TagsAllQuery,
      update(data) {
        const allRelatedTags =
          this.tagStats.flatMap(({ relatedTags }) => relatedTags) || [];
        if (!allRelatedTags.length) {
          return data.tagsAll;
        }

        const currentRelatedTagsIds = new Set(
          this.editRelatedTags.relatedTags.map((tag) => tag.id)
        );
        const allRelatedTagsIds = new Set(allRelatedTags.map((tag) => tag.id));

        return data.tagsAll.filter(
          (tag) =>
            tag.isActive &&
            (currentRelatedTagsIds.has(tag.id) ||
              !allRelatedTagsIds.has(tag.id))
        );
      },
      skip() {
        return this.editRelatedTags == null;
      },
    },
  },
};
</script>
